module.exports = __webpack_public_path__ + "static/media/sf-test-6.a461428f.mp3";